
(function() {

let legalInfoCompanyForReport = $('#legal_info_company');

$(legalInfoCompanyForReport).ready(function(){
   if($(legalInfoCompanyForReport).is(':visible')){
            $.post('/get_legal_info_company_for_report', { _token: $('meta[name="csrf-token"]').attr('content')}, function(responce) {
            legalInfoCompanyForReport.html(responce);
        });
  }
});

})();